var exports = {
  "k": "xa15a2ab7--6fe387--container",
};

module.exports = exports;
